import { MicroTaskConfig } from 'ihub/common';
import { CRUDHelperBase } from '../classes/crud-helper-base';
import { getTenantID } from '../classes/http-helper-const';
import HttpResponseOptions from '../interface/http-response-options';
import QueryClientWrapper from '../utils/create-query-client';
import { GetSchemaKey } from './schema-http.service';

export class TaskHttpService extends CRUDHelperBase<MicroTaskConfig> {
	constructor() {
		super(MicroTaskConfig.name);
	}

	async save(item: MicroTaskConfig, options?: HttpResponseOptions): Promise<void> {
		QueryClientWrapper.InvalidateKey([getTenantID(), GetSchemaKey]);
		await super.save(item, options);
	}
}
